import { HTMLAttributes } from 'react';
import { Entry } from 'types';
import { CopyButton, Text } from 'components';
import { integerToCurrency, removeCurrencySign } from 'helpers';
import { FontSize, FontWeight, TEST_IDS } from 'commons';
import { Image } from './components';
import * as S from './styles';

interface Props extends HTMLAttributes<HTMLDivElement> {
  entry: Entry;
  hideCopyButton?: boolean;
  status?: 'default' | 'success' | 'error';
  clearBorder?: boolean;
}

export function Product({
  entry,
  hideCopyButton = false,
  status,
  clearBorder = false,
  children,
}: Props) {
  const {
    product,
    quantity,
    basePrice,
    unitPriceWithDistributedDiscountPrice: unitPrice,
    priceWithDistributedDiscountPrice,
    hasFreeBag,
  } = entry;
  const { image, name, code } = product;
  const totalFormatted = integerToCurrency(
    priceWithDistributedDiscountPrice.value
  );

  const renderUnitPrice = (() => {
    if (basePrice.value === unitPrice.value) {
      return (
        <S.TextWrapper>
          <S.TextContainer $size="large">
            <Text size={FontSize.font12}>Valor</Text>
          </S.TextContainer>

          <Text size={FontSize.font12}>
            {integerToCurrency(basePrice.value)}
          </Text>
        </S.TextWrapper>
      );
    }

    return (
      <S.TextWrapper>
        <S.TextContainer $invalid $size="medium">
          <Text size={FontSize.font12}>
            De {integerToCurrency(basePrice.value)}
          </Text>
        </S.TextContainer>

        <S.TextWrapper>
          <S.TextContainer $size="small">
            <Text size={FontSize.font12}>Por</Text>
          </S.TextContainer>

          <Text size={FontSize.font12}>
            {integerToCurrency(unitPrice.value)}
          </Text>
        </S.TextWrapper>
      </S.TextWrapper>
    );
  })();

  return (
    <S.Main
      data-testid={TEST_IDS.PRODUCT_COMPONENT}
      $status={status}
      $clearBorder={clearBorder}
    >
      <S.ImageContainer>
        <Image src={image} alt={name || code} />
      </S.ImageContainer>

      <S.Container>
        {name && <Text size={FontSize.font12}>{name}</Text>}

        <S.Wrapper>
          <S.InfosWrapper>
            <S.IconWrapper>
              <Text size={FontSize.font12} weight={FontWeight.bold}>
                {code}
              </Text>

              {!hideCopyButton && <CopyButton content={code} />}
            </S.IconWrapper>

            <S.TextWrapper>
              <S.TextContainer $size="large">
                <Text size={FontSize.font12}>Quantidade</Text>
              </S.TextContainer>

              <Text size={FontSize.font12} weight={FontWeight.bold}>
                {quantity}
              </Text>
            </S.TextWrapper>

            {renderUnitPrice}

            <S.IconWrapper>
              <S.TextWrapper>
                <S.TextContainer $size="large">
                  <Text size={FontSize.font12}>Total</Text>
                </S.TextContainer>

                <Text size={FontSize.font12} weight={FontWeight.bold}>
                  {totalFormatted}
                </Text>
              </S.TextWrapper>

              {!hideCopyButton && (
                <CopyButton content={removeCurrencySign(totalFormatted)} />
              )}
            </S.IconWrapper>

            <S.TextWrapper>
              <S.TextContainer $size="large">
                <Text size={FontSize.font12}>Embalagem para presente</Text>
              </S.TextContainer>

              <Text size={FontSize.font12} weight={FontWeight.bold}>
                {hasFreeBag ? 'Sim' : 'Não'}
              </Text>
            </S.TextWrapper>
          </S.InfosWrapper>

          <S.InnerContainer>{children}</S.InnerContainer>
        </S.Wrapper>
      </S.Container>
    </S.Main>
  );
}
